import { userService } from "../api/user-auth";
import router from "../router";

const user = JSON.parse(localStorage.getItem("user"));
const state = user
  ? { status: { loggedIn: true }, user }
  : { status: {}, user: null };

const actions = {
  login({ dispatch, commit }, { username, password }) {
    commit("loginIn", user);
    userService.login(username, password).then(
      (user) => {
        if (user.ok) {
          dispatch("vehicles/getVehicles", null, { root: true });
          dispatch("schedule/getSchedule", null, { root: true });
          dispatch("customers/getCustomers", null, { root: true });
          dispatch("personnels/getPersonnels", null, { root: true });
          dispatch("sites/getSites", null, { root: true });
          dispatch("plants/getPlants", null, { root: true });
          dispatch("users/getUsers", null, { root: true });
          dispatch("jobs/getJobs", null, { root: true });
          commit("loginSuccess", user);
          router.push("/");
        } else {
          commit("loginFailure", user);
          dispatch("alert/error", user.message, { root: true });
        }
      },
      (error) => {
        commit("loginFailure", error);
        dispatch("alert/error", error, { root: true });
      }
    );
  },
  logout({ commit }) {
    userService.logout();
    commit("logout");
  },
  register({ dispatch, commit }, user) {
    commit("registerRequest", user);

    userService.register(user).then(
      (user) => {
        commit("registerSuccess", user);
        router.push("/login");
        setTimeout(() => {
          // display success message after route change completes
          dispatch("alert/success", "Registration successful", { root: true });
        });
      },
      (error) => {
        commit("registerFailure", error);
        dispatch("alert/error", error, { root: true });
      }
    );
  },
};

const mutations = {
  loginIn(state) {
    state.status = { loggingIn: true };
    state.user = null;
  },
  loginSuccess(state, user) {
    state.status = { loggedIn: true };
    state.user = user;
  },
  loginFailure(state) {
    state.status = {};
    state.user = null;
  },
  logout(state) {
    state.status = {};
    state.user = null;
  },
  // eslint-disable-next-line no-unused-vars
  registerRequest(state, user) {
    state.status = { registering: true };
  },
  // eslint-disable-next-line no-unused-vars
  registerSuccess(state, user) {
    state.status = {};
  },
  // eslint-disable-next-line no-unused-vars
  registerFailure(state, error) {
    state.status = {};
  },
};

export const account = {
  namespaced: true,
  state,
  actions,
  mutations,
};
